var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CampaignBudget'),_vm._v(" "),_c('hr',{staticClass:"divider"}),_vm._v(" "),_c('CampaignDailyCap')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }